<template>
  <div class="wrapper">
    <div class="project">
      <div class="project__header">
        <div class="project__title">
          <p class="project__upper">الزبون</p>
          <h4>{{ project.title }}</h4>
        </div>
        <div class="project__services">
          <h6>الخدمات</h6>
          <ul>
            <li v-for="service in project.services" :key="service">{{ service }}</li>
          </ul>
        </div>
      </div>
      <div class="project__images">
        <!-- <div class="project__image-wrap" v-for="image in project.images" :key="image"> -->
        <img class="project__image" v-for="image in project.images" :key="image" :src="getImgUrl(image)" :alt="`${project.title}-${image}`">
        <!-- </div> -->
      </div>
    </div>
    <contact/>
  </div>
</template>

<script>
import Projects from '@/data/projects'
import Contact from '@/components/Contact'

export default {
  components: {
    Contact
  },
  props: {
    slug: String
  },
  data () {
    return {
      project: Projects.find(elm => elm.slug === this.slug)
    }
  },
  methods: {
    getImgUrl (img) {
      var images = require.context('@/assets/', false, /\.jpg$/)
      return images('./' + img + '.jpg')
    }
  }
}
</script>

<style lang="scss">
.project__services h6 {
    margin-bottom: .5rem;
    // font-family: Montserrat Semi Bold;
}

.project__services {
    margin: 2rem 0;
}

.project__upper {
  margin-bottom: -.75rem;
  font-size: .8rem;
  font-weight: lighter;
  // opacity: .85;
}

.project__images {
    // display: grid;
    grid-gap: 2rem;

  @media screen and (min-width: 640px) {
    grid-template-columns: repeat(2,1fr);
  }

  @media screen and (min-width: 960px) {
    grid-gap: 4rem;
  }

  img:not(:first-child) {
    margin-top: 4rem;
  }
}

.project__image-wrap {
  position: relative;
  overflow: hidden;
  height: 60vh;

  @media screen and (min-width: 640px) {
    &:nth-of-type(3n+1) {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }

  .project__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
    // opacity: 0;
    // transition: opacity .3s cubic-bezier(.43,.26,.13,1.01);
  }
}
</style>
